import { render, staticRenderFns } from "./UserName.vue?vue&type=template&id=5610a9ba&scoped=true"
import script from "./UserName.vue?vue&type=script&lang=js"
export * from "./UserName.vue?vue&type=script&lang=js"
import style0 from "./UserName.vue?vue&type=style&index=0&id=5610a9ba&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5610a9ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/program/front/git/ams/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5610a9ba')) {
      api.createRecord('5610a9ba', component.options)
    } else {
      api.reload('5610a9ba', component.options)
    }
    module.hot.accept("./UserName.vue?vue&type=template&id=5610a9ba&scoped=true", function () {
      api.rerender('5610a9ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/UserName.vue"
export default component.exports